import React, {Component} from "react";
import "./Controllers.css"
import {loadAndCheckCredentials} from "./App";
import "./App"

export function ViewSelectorButton(props) {

    function changeView(e) {
        props.changeView(props.view, e);
    }

    let text = ["Sessioni", "Domande", "Zone"][props.view];
    return <button className={'ViewSelectorButton' + (props.selected ? " ViewSelectorButtonSelected" : "")}
                   onClick={changeView}>
        {text}</button>
}

export class UpdateAuthButton extends React.Component {
    constructor(props) {
        super(props);
        this.updateCredentials = this.updateCredentials.bind(this)
    }

    updateCredentials() {
        this.props.onHasAuthChanged(false);
    }

    render() {
        return (
            <button className="UpdateCredentialsButton" onClick={this.updateCredentials}>Aggiorna Credenziali</button>
        )
    }
}

export function CancelButton(props) {
    return (
        <button className="button cancelButton" onClick={props.onClick}>Annulla</button>
    );
}

export function ConfirmButton(props) {
    return (
        <button className="button confirmButton" onClick={props.onClick}>Conferma</button>
    );
}

export function CategorySelector(props) {
    const categories = ['Free', 'SalaCapire', 'SalaConoscere', 'SalaRisparmiare', 'SalaSperimentare', 'SalaSognare'].map(cat =>
        <option key={cat} value={cat}>{cat}</option>);
    return (
        <select name={props.name} onChange={props.onChange} className="selectInput" value={props.value}>
            {categories}
        </select>
    );
}

export class AuthenticationPanel extends React.Component {
    constructor(props) {
        super(props);
        this.state = {appKey: global.appKey, username: global.username, password: global.password};
        this.handleInputChange = this.handleInputChange.bind(this);
        this.handleUpdateButtonClick = this.handleUpdateButtonClick.bind(this);
    }

    handleInputChange(event) {
        this.setState({[event.target.name]: event.target.value})
    }

    handleUpdateButtonClick() {
        localStorage.setItem("appKey", this.state.appKey);
        localStorage.setItem("username", this.state.username);
        localStorage.setItem("password", this.state.password);
        if (!loadAndCheckCredentials()) {
            alert("Credenziali mancanti. Riempi tutti i campi.");
            return;
        }
        this.props.onHasAuthChanged(true);
    }

    render() {
        return (
            <div className="AuthenticationPanel">
                <label className="smallHeader">AppKey:</label>
                <input name='appKey' type="text" className="textInput" onChange={this.handleInputChange} value={this.state.appKey}/>
                <br/>
                <label className="smallHeader">Username:</label>
                <input name='username' type="text" className="textInput" onChange={this.handleInputChange} value={this.state.username}/>
                <br/>
                <label className="smallHeader">Password:</label>
                <input name='password' type="password" className="textInput" onChange={this.handleInputChange} value={this.state.password}/>
                <br/>
                <button className="button purple" onClick={this.handleUpdateButtonClick}>Aggiorna</button>
            </div>
        );
    }
}
